var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-ex" }, [
    _vm._m(0),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
    _vm._m(4),
    _c("p", { staticStyle: { "text-indent": "27.7pt" } }),
    _c("br"),
    _c("p", { staticStyle: { "text-indent": "24.1pt" } }, [
      _vm._v(" 被授权方："),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.user_company))])
        : _vm._e(),
      _vm._v("（以下简称乙方） ")
    ]),
    _c("p", { staticStyle: { "text-indent": "23.7pt" } }, [
      _vm._v(" 营业地址： "),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.user_business_address))])
        : _vm._e()
    ]),
    _c("p", { staticStyle: { "text-indent": "23.55pt" } }, [
      _vm._v(" 法定代表人："),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.user_legal_person))])
        : _vm._e()
    ]),
    _c("p", { staticStyle: { "text-indent": "23.55pt" } }, [
      _vm._v(" 经营者身份证号码："),
      _vm.company
        ? _c("u", [_vm._v(_vm._s(_vm.company.userInfo.card_id))])
        : _vm._e()
    ]),
    _c("p", { staticStyle: { "text-indent": "23.7pt" } }, [
      _vm._v(" 电话： "),
      _c("u", [_vm._v(_vm._s(_vm.company.userInfo.phone))])
    ]),
    _c("br"),
    _vm._m(5),
    _vm._m(6),
    _vm._m(7),
    _vm._m(8),
    _vm._m(9),
    _vm._m(10),
    _vm._m(11),
    _vm._m(12),
    _vm._m(13),
    _vm._m(14),
    _vm._m(15),
    _vm._m(16),
    _vm._m(17),
    _vm._m(18),
    _vm._m(19),
    _vm._m(20),
    _vm._m(21),
    _vm._m(22),
    _vm._m(23),
    _c("p", [_vm._v("甲方（签字或盖章）： 乙方（签字或盖章）： ")]),
    _c("p", [_vm._v("日期： 日期： ")]),
    _vm._m(24)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "center" } }, [
      _c("strong", [_vm._v("代存储、发货合作协议书")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "justify" } }, [
      _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "24pt" } }, [
      _vm._v(" 授权方："),
      _c("u", [_vm._v(" 大连景盛铭泰商贸有限公司 ")]),
      _vm._v("（以下简称甲方） ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "22.8pt" } }, [
      _vm._v(" 法定代表人："),
      _c("u", [_vm._v(" 许兆旻 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-indent": "22.8pt" } }, [
      _vm._v(" 注册地址："),
      _c("u", [_vm._v(" 辽宁省大连保税区自贸大厦816室 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "根据《中华人民共和国民法典》有关规定，结合乙方是甲方指定桃花养元汤、桃花固元汤、龙颜大悦奶茶等系列产品的代理经销商，甲乙双方经友好协商，达成以下合作意向："
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("一、合作方式及条件")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、乙方经销甲方生产的桃花养元汤、桃花固元汤、龙颜大悦奶茶等系列产品，乙方定购的货物可以直接提走，也可以由甲方代为储存、代为发货。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、乙方委托甲方代为存储、发货的，甲方选择正规的物流公司根据乙方提供的订单信息，分批次将货物发送至指定地点，但每次发运量必须为10盒的整数倍。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "3、乙方将订单和汇款凭证一同扫描发送到甲方，甲方确认到账后，以乙方订单为准"
          )
        ]),
        _c("u"),
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("个工作日内进行发货。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "4、甲方根据乙方的订单发货，运费由甲方承担，但如因乙方填写地址不详、无人收货等原因造成的二次运费由乙方承担。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "5、当甲、乙双方终止合作或乙方订购甲方其他种类产品时，乙方已交付的采购款不能退还，已订购产品不能向甲方申请退货，但可以向甲方申请将剩余产品委托甲方代为销售。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("二、权利与义务")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、在运输途中因物流公司原因，发生货物损坏或缺少丢失的，甲方不承担任何责任，由乙方与物流公司交涉。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、甲方有义务和责任保质保量及时发出乙方委托代发的货物，若产品缺货，甲方应提前通知乙方。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "3、如果因为错发或者质量问题造成的退换货，甲方承担往返运费；乙方和客户之间达成的其他退换货协议与甲方无关，非产品质量原因客户要求退换货，乙方承担全部责任。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("strong", [_vm._v("三、其它约定")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "1、任何一方由于不可抗力造成的部分或全部不能履行本协议书的义务的行为将不视为违约，但应在条件允许下采取一切合理及实际可行的补偿措施，以减少因不可抗力造成的损失。 "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "2、凡因履行本协议书所发生的或与本协议书有关的一切争议，双方应首先通过有好方式协商解决，如果协商不能解决，应提请甲方所在地法院适用中华人民共和国法律诉讼解决，费用由乙方负担。 "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v("3、本合同经双方签字盖章即生效，传真件具有同等法律效力。")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [
        _c("span", { staticStyle: { color: "rgb(0, 0, 0)" } }, [
          _vm._v(
            "4、合同文本一式贰份，甲乙双方各执一份为凭，具有同等法律效力。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "text-indent": "25.6pt", "text-align": "justify" } },
      [_c("span", { staticStyle: { color: "rgb(0, 0, 0)" } })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }